export const CANOPY_PREFIX = '/canopy'

export function canopyPath(path: string): string {
  if (!path.startsWith('/')) {
    throw new Error(`Route path must start with "/": received "${path}"`)
  }
  return `${CANOPY_PREFIX}${path}`
}

export function sharedPath(path: string): string {
  if (!path.startsWith('/')) {
    throw new Error(`Route path must start with "/": received "${path}"`)
  }
  return path
}

export const CHAT_SOCKET_PATH = canopyPath('/ai/ws')
